/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StatisticsSummaryMarketData model module.
 * @module model/StatisticsSummaryMarketData
 * @version 1.0
 */
class StatisticsSummaryMarketData {
    /**
     * Constructs a new <code>StatisticsSummaryMarketData</code>.
     * @alias module:model/StatisticsSummaryMarketData
     */
    constructor() { 
        
        StatisticsSummaryMarketData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StatisticsSummaryMarketData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StatisticsSummaryMarketData} obj Optional instance to populate.
     * @return {module:model/StatisticsSummaryMarketData} The populated <code>StatisticsSummaryMarketData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StatisticsSummaryMarketData();

            if (data.hasOwnProperty('totalCarRegisterCount')) {
                obj['totalCarRegisterCount'] = ApiClient.convertToType(data['totalCarRegisterCount'], 'Number');
            }
            if (data.hasOwnProperty('totalCarTransactionCount')) {
                obj['totalCarTransactionCount'] = ApiClient.convertToType(data['totalCarTransactionCount'], 'Number');
            }
            if (data.hasOwnProperty('totalCarBoxRegisterCount')) {
                obj['totalCarBoxRegisterCount'] = ApiClient.convertToType(data['totalCarBoxRegisterCount'], 'Number');
            }
            if (data.hasOwnProperty('totalCarBoxTransactionCount')) {
                obj['totalCarBoxTransactionCount'] = ApiClient.convertToType(data['totalCarBoxTransactionCount'], 'Number');
            }
            if (data.hasOwnProperty('totalItemRegisterCount')) {
                obj['totalItemRegisterCount'] = ApiClient.convertToType(data['totalItemRegisterCount'], 'Number');
            }
            if (data.hasOwnProperty('totalItemTransactionCount')) {
                obj['totalItemTransactionCount'] = ApiClient.convertToType(data['totalItemTransactionCount'], 'Number');
            }
            if (data.hasOwnProperty('totalGemRegisterCount')) {
                obj['totalGemRegisterCount'] = ApiClient.convertToType(data['totalGemRegisterCount'], 'Number');
            }
            if (data.hasOwnProperty('totalGemTransactionCount')) {
                obj['totalGemTransactionCount'] = ApiClient.convertToType(data['totalGemTransactionCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>StatisticsSummaryMarketData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>StatisticsSummaryMarketData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} totalCarRegisterCount
 */
StatisticsSummaryMarketData.prototype['totalCarRegisterCount'] = undefined;

/**
 * @member {Number} totalCarTransactionCount
 */
StatisticsSummaryMarketData.prototype['totalCarTransactionCount'] = undefined;

/**
 * @member {Number} totalCarBoxRegisterCount
 */
StatisticsSummaryMarketData.prototype['totalCarBoxRegisterCount'] = undefined;

/**
 * @member {Number} totalCarBoxTransactionCount
 */
StatisticsSummaryMarketData.prototype['totalCarBoxTransactionCount'] = undefined;

/**
 * @member {Number} totalItemRegisterCount
 */
StatisticsSummaryMarketData.prototype['totalItemRegisterCount'] = undefined;

/**
 * @member {Number} totalItemTransactionCount
 */
StatisticsSummaryMarketData.prototype['totalItemTransactionCount'] = undefined;

/**
 * @member {Number} totalGemRegisterCount
 */
StatisticsSummaryMarketData.prototype['totalGemRegisterCount'] = undefined;

/**
 * @member {Number} totalGemTransactionCount
 */
StatisticsSummaryMarketData.prototype['totalGemTransactionCount'] = undefined;






export default StatisticsSummaryMarketData;

